import React from "react";
import Products from "../components/Products";
import usePageMeta from "../hooks/usePageMeta";

const CatalogPage = () => {
    usePageMeta({
        title: "Tous les produits — accessoires téléphone Maroc | Atelier AX",
        description:
            "Tout le catalogue : coques, chargeurs, câbles, power banks au meilleur prix en DH. Livraison 24-72h partout au Maroc, paiement à la livraison.",
        path: "/produits",
    });

    return (
        <main>
            <div className="max-w-[1320px] mx-auto px-4 sm:px-6 md:px-10 pt-8 md:pt-12">
                <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-[#1C1C1E]">
                    Tous nos accessoires téléphone au Maroc
                </h1>
                <p className="mt-2 text-[14px] text-neutral-500 max-w-2xl">
                    Coques, chargeurs, câbles, batteries externes et accessoires audio :
                    prix en DH, livraison 24-72h partout au Maroc, paiement à la livraison.
                </p>
            </div>
            <Products />
        </main>
    );
};

export default CatalogPage;
